export default __webpack_public_path__ + "static/media/notification-warning-filled.6212ed45.svg";